import classNames from 'classnames';
import { format } from 'date-fns';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import CalcStatus from '../../../../components/common/CalcStatus';
import MenuButton from '../../../../components/common/MenuButton';
import PolicyRequired from '../../../../components/common/PolicyRequired';
import { formatTime } from '../../../../services/formatTime';
import { getWeekDaysText } from '../../../../services/weekDays';
import { Contract } from '../../../../types/contracts';
import styles from './styles.module.css';

const getCollectionDateText = (contract: Contract) => {
  const date = contract.endDate ? (
    <div>
      {format(new Date(contract.startDate), 'yyyy/M/d')}-<wbr />
      {format(new Date(contract.endDate), 'yyyy/M/d')}
    </div>
  ) : (
    <div>{format(new Date(contract.startDate), 'yyyy/M/d')}</div>
  );
  const weekday = (
    <div>{getWeekDaysText(contract.collectionConstraintWeekDays)}</div>
  );
  const times =
    contract.specificTimeStartAt && contract.specificTimeEndAt ? (
      <div>
        {contract.specificTimeStartAt
          ? formatTime(contract.specificTimeStartAt)
          : undefined}
        -
        {contract.specificTimeEndAt
          ? formatTime(contract.specificTimeEndAt)
          : undefined}
      </div>
    ) : null;
  return (
    <>
      {date}
      {weekday}
      {times}
    </>
  );
};

type Props = {
  contracts: Contract[];
};
const ContractsTable: FC<Props> = ({ contracts }) => {
  return (
    <table className={classNames(styles.table, 'rounded-corners')}>
      <thead>
        <tr className={styles.head}>
          <th className={classNames(styles.headCell, styles.carAllocate)}>
            計算
          </th>
          <th className={classNames(styles.headCell, styles.contractNo)}>
            契約No
          </th>
          <th className={classNames(styles.headCell, styles.collectionDate)}>
            回収日
          </th>
          <th
            className={classNames(styles.headCell, styles.supplierCompanyName)}
          >
            排出事業者
          </th>
          <th
            className={classNames(
              styles.headCell,
              styles.contractorCompanyName
            )}
          >
            委託先
          </th>
          <th
            className={classNames(
              styles.headCell,
              styles.wastePointCompanyName
            )}
          >
            排出事業場
          </th>
          <th className={classNames(styles.headCell, styles.workCategory)}>
            作業
          </th>
          <th className={classNames(styles.headCell, styles.wasteItems)}>
            廃棄品目
          </th>
          <th className={classNames(styles.headCell, styles.etc)}></th>
        </tr>
      </thead>
      <tbody>
        {contracts.map((c) => (
          <tr key={c.contractId}>
            <td className={styles.dataCell}>
              <CalcStatus {...c} />
            </td>
            <td className={styles.dataCell}>
              <div className={styles.contractNoCell}>{c.contractNo}</div>
            </td>
            <td className={styles.dataCell}>
              <div className={styles.collectionDateCell}>
                {getCollectionDateText(c)}
              </div>
            </td>
            <td className={styles.dataCell}>
              <div className={styles.companyNameCell}>
                {c.supplierCompany?.name}
              </div>
            </td>
            <td className={styles.dataCell}>
              <div className={styles.companyNameCell}>
                {c.contractorCompany?.name}
              </div>
            </td>
            <td className={styles.dataCell}>
              <div className={styles.companyNameCell}>
                {c.wastePointCompany?.name}
              </div>
            </td>
            <td className={styles.dataCell}>
              <div className={styles.workCategories}>
                {c.goesStraight ? '直行' : '積保'}
              </div>
            </td>
            <td className={styles.dataCell}>
              <div className={styles.wasteItemsText}>
                {c.wasteItems[0] &&
                  `${c.wasteItems[0].id}.${c.wasteItems[0].name}`}
              </div>
            </td>
            <td
              className={classNames(styles.dataCell, styles.ellipsisContainer)}
            >
              <MenuButton>
                {({ close, itemClassName }) => (
                  <>
                    <PolicyRequired policy={20}>
                      <Link
                        to={`edit/${c.contractId}`}
                        className={itemClassName}
                        onClick={close}
                      >
                        編集
                      </Link>
                    </PolicyRequired>
                    <Link
                      to={`copy/${c.contractId}`}
                      className={itemClassName}
                      onClick={close}
                    >
                      複製
                    </Link>
                  </>
                )}
              </MenuButton>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ContractsTable;
